import React from 'react';
import { BRAND } from '../data/content';
import { FacebookIcon, InstagramIcon, WhatsappIcon, YoutubeIcon } from './icons/LineIcons';
type SocialLinksProps = {
  className?: string;
  size?: 'sm' | 'md';
};
const links = [{
  label: 'Instagram',
  href: BRAND.instagramUrl,
  Icon: InstagramIcon
}, {
  label: 'Facebook',
  href: BRAND.facebookUrl,
  Icon: FacebookIcon
}, {
  label: 'YouTube',
  href: BRAND.youtubeUrl,
  Icon: YoutubeIcon
}, {
  label: 'WhatsApp',
  href: BRAND.whatsappUrl,
  Icon: WhatsappIcon
}];
export function SocialLinks({
  className = '',
  size = 'md'
}: SocialLinksProps) {
  const box = size === 'sm' ? 'w-9 h-9' : 'w-11 h-11';
  const icon = size === 'sm' ? 'w-4 h-4' : 'w-5 h-5';
  return <ul className={`flex items-center gap-3 ${className}`} data-id="element-343" data-mp="zu156ud7eqy3">
      {links.map(({
      label,
      href,
      Icon
    }) => <li key={label} data-id="element-344" data-mp="1xb8941bhz1nb">
          <a href={href} target="_blank" rel="noopener noreferrer" aria-label={label} className={`${box} grid place-items-center rounded-md border border-steel/80 text-white/80 transition-all duration-300 hover:text-gold hover:border-gold/60 hover:shadow-[0_0_22px_-6px_rgba(245,197,24,0.65)]`} data-id="element-345" data-mp="1xbrigtn30hpq">
            <Icon className={icon} data-id="element-346" data-mp="1oqvz7gtbhuq5" />
          </a>
        </li>)}
    </ul>;
}